__turbopack_context__.v({
  "AmosAir": "Header-module-sass-module__8cHKOa__AmosAir",
  "Bems": "Header-module-sass-module__8cHKOa__Bems",
  "Cont": "Header-module-sass-module__8cHKOa__Cont",
  "HasScrolled": "Header-module-sass-module__8cHKOa__HasScrolled",
  "Header": "Header-module-sass-module__8cHKOa__Header",
  "Home": "Header-module-sass-module__8cHKOa__Home",
  "HydroIndustries": "Header-module-sass-module__8cHKOa__HydroIndustries",
  "Inner": "Header-module-sass-module__8cHKOa__Inner",
  "Logo": "Header-module-sass-module__8cHKOa__Logo",
  "MenuButton": "Header-module-sass-module__8cHKOa__MenuButton",
  "MenuOpen": "Header-module-sass-module__8cHKOa__MenuOpen",
  "NearBottom": "Header-module-sass-module__8cHKOa__NearBottom",
});
